import React from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

interface MenuIconPlainProps {
  icon: TablerIcons
  className?: string
  onClick?: (e: React.MouseEvent) => void
  size?: 16 | 24 | 32
}

const TwMenuIconContainer = tw.div``

export const MenuIconPlain = (props: MenuIconPlainProps) => {
  const {size = 16, icon, className, onClick} = props

  return (
    <TwMenuIconContainer className={className} onClick={onClick}>
      <Icon
        icon={icon}
        size={size}
        color="panel-icon-primary"
        type="main-menu"
      />
    </TwMenuIconContainer>
  )
}
